import axios from 'axios';
import { API } from '@/App';

export const uploadPaymentProof = async ({ file, context, deliveryId }) => {
  if (!file) {
    throw new Error('PAYMENT_PROOF_REQUIRED');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('context', context);
  if (deliveryId) {
    formData.append('delivery_id', deliveryId);
  }

  const response = await axios.post(`${API}/payments/proofs/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data?.data?.file || null;
};

